import { useCallback, useEffect, useState } from 'react'

const useWindowDimensions = () => {
  const hasWindow = typeof window !== 'undefined'
  const getWindowDimensions = useCallback(
    () => ({
      width: document?.documentElement?.clientWidth || null,
      height: document?.documentElement?.clientHeight || null,
    }),
    []
  )
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  )
  useEffect(() => {
    if (hasWindow) {
      const handleResize = () => {
        setWindowDimensions(getWindowDimensions())
      }
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    }
  }, [hasWindow, getWindowDimensions])

  return windowDimensions
}

export default useWindowDimensions
